import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "./Hero";
import Services from "./Services";
import About from "./About";
import FeatureSection from "./FeatureSection";
import SectionHeader from "./SectionHeader";
import Applications from "./Applications";
import Contact from "./Contact";
import Footer from "./Footer";

import basketImg from "../images/basket.png";
import roadmapImg from "../images/roadmap.png";
import architectureImg from "../images/architecture.png";
import AWSAIImg from "../images/AWS_AI_Architecture.png";

export default function Home() {
  const location = useLocation();

  // If arriving with a hash (e.g. /#about from another page), scroll to it
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Delay to ensure sections are rendered
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <Services />
      <About />
      <FeatureSection
        id="metabettatoohard"
        subheading="Making your life easier"
        heading="Let us sort your Too Hard Basket."
        description="From security to  privacy data mapping to developing financial modelling, we're here to make your life easier and take on the jobs you don't have the capacity to do internally. With a wealth of digital experience at both enterprise and start-up scale, we've been hands on with all aspects of tech and compliance."
        imageSrc={basketImg}
        textOnLeft={true}
      />
      <SectionHeader
        id="business"
        heading="Our Business Solutions"
        description="From product roadmap, code and architecture reviews, data mapping, privacy, security, compliance to forecasting, we offer the full scope of business support for any technology business."
      />
      <FeatureSection
        id="metabettadata"
        subheading="Data based solutions"
        heading="Forecasting & Analysis"
        description="We can take your data, customer analytics and past performance and develop forecasting models, roadmaps and means to get from now to where you need to be. We custom build to suit every client, so we're making sure every solution is tailored to you, not just applying broad generalities."
        imageSrc={roadmapImg}
        textOnLeft={false}
      />
            <FeatureSection
        id="metabettaai"
        subheading="How to securely use AI in the cloud without compromising customer data and data sovereignty"
        heading="Scalable Enterprise AI Advice"
        description="From a foundation of Context Architecture and AWS hosted Frontier LLM Models, we can show you how to keep your AI costs down and your productivity up by embedding your organisational knowledge into the design."
        imageSrc={AWSAIImg}
        textOnLeft={true}
      />
      <FeatureSection
        id="metabettadataarch"
        subheading="Best in class methods and recommendations"
        heading="Enterprise Architecture, Cybersecurity and Mapping"
        description="With over 25 years of experience at planning, securing, pentesting, mapping, documenting and delivering solutions at Enterprise Scale, we can help analyse, secure, improve, redesign or simply get a sense check on your systems."
        imageSrc={architectureImg}
        textOnLeft={false}
      />
      {/* <SectionHeader
        id="music"
        heading="Music Industry Data"
        description="As well as offering consultancy, we also develop our own proprietary software and run our own database organising, compiling and deduplicating all official music data sources for the music rights management market."
      /> */}
      <Applications />
      <Contact />
      <SectionHeader
        id="why"
        heading="Why Metabetta?"
        description={
          <>
            Metabetta was here before Meta was Meta. The name has been registered in Australia since 30 September 2020,
            more than a year before Facebook rebranded to Meta in October 2021. 'Meta' is about seeing the bigger
            picture and thinking a level above the problem. 'Betta', if you're Australian, is simply <em>heaps</em>{" "}
            better.
          </>
        }
      />
      <Footer />
    </>
  );
}
